
<template>
  <!--钥匙分配-->
  <div class="step-form">
    <a-steps class="steps" :current="currentStep" :status="stepStatus">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" />
    </a-steps>

    <a-form class="content" :form="form">
      <template v-if="currentStep===0">
        <a-form-item v-bind="$store.state.step_ItemLayout" label="小区" has-feedback>
          <a-select
            v-decorator="['communityId', decoratorOptions.communityId]"
            :filterOption="filterOption"
            :default-active-first-option="false"
            allowClear
            showSearch
            @change="e => { queryType && selectChange(e) }"
            @search="selectSearch($event)"
            @popupScroll="selectScroll($event)"
            placeholder="请选择小区">
            <a-select-option v-for="(item, index) of communityList" :key="index" :value="item.value">
              {{item.label}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="$store.state.step_ItemLayout" label="账号" has-feedback>
          <a-select
            v-if="queryType"
            v-decorator="['userId', decoratorOptions.userId]"
            :filterOption="filterOption"
            allowClear
            showSearch
            placeholder="请选择账号">
            <a-select-option v-for="(item, index) of userList" :key="index" :value="item.value">
              {{item.label}}
            </a-select-option>
          </a-select>

          <a-input v-else v-decorator="['mobile', decoratorOptions.mobile]" placeholder="请输入手机" allowClear/>
        </a-form-item>
      </template>

      <template v-if="currentStep===1">
        <a-form-item v-bind="$store.state.step_ItemLayout" label="小区">
          <span class="ant-form-text">{{roomData.communityName}}</span>
        </a-form-item>

          <a-form-item v-bind="$store.state.step_ItemLayout" label="账号">
            <span class="ant-form-text">{{roomData.mobile}}</span>
          </a-form-item>

          <a-form-item v-bind="$store.state.step_ItemLayout" label="房间" v-if="queryType !== 'steward'">
            <p
              class="ant-form-text"
              :style="{display: 'block'}"
              v-for="(item, index) of roomData.roomList"
              :key="index"
            >{{item.roomAddress}}</p>
          </a-form-item>

          <a-form-item label="设备列表" v-bind="$store.state.step_ItemLayout">
            <a-transfer
              :listStyle="{ width: '230px', height: '300px' }"
              v-decorator="['deviceIds', decoratorOptions.deviceIds]"
              @change="transferChange"
              :dataSource="dataSource"
              :titles="['可选设备', '已选设备']"
              :targetKeys="targetKeys"
              showSearch
              :filterOption="transferFilter"
              :render="item => item.title"
            />
          </a-form-item>
      </template>

      <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
        <div class="steps-action">
          <a-button v-if="currentStep < steps.length - 2" type="primary" @click="next" size="large">下一步</a-button>
          <a-button v-if="currentStep === steps.length - 2" type="primary" @click="handleSubmit" :loading="btnLoading.loading" size="large">立即分配</a-button>
          <a-button v-if="currentStep>0" :style="{marginLeft: '8px'}" @click="lastStep" size="large">上一步</a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { fetchSelect } from '../../../utils/mixins';
import { inputSearch, addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [inputSearch, fetchSelect, addEdit],
  name: 'allocation',
  data () {
    return {
      isFetched: false,
      selectCurrentPage: 1,
      totalPage: 2,
      searchValue: undefined,
      queryType: '',
      roomData: { roomList: [] },
      apiObj: {},
      btnLoading: { loading: false },
      formValues: {},
      targetKeys: [],
      currentStep: 0,
      stepStatus: 'process',
      steps: [{ title: '填写账号信息' }, { title: '确认分配钥匙' }, { title: '完成' }],
      dataSource: [],
      communityList: [],
      userList: [],
      decoratorOptions: {
        communityId: {
          rules: [{ required: true, message: '请选择小区' }]
        },
        mobile: {
          rules: [
            { required: true, message: '请输入手机号' },
            { pattern: this.REG.mobile, message: this.MESSAGE.mobile }
          ]
        },
        deviceIds: {
          rules: [{ required: true, message: '请选择设备' }]
        },
        userId: {
          rules: [{ required: true, message: '请选择账号' }]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.queryType = this.$route.query.type;
    if (this.queryType) {
      this.apiObj = {
        nextApi: '/property/passKey/authentication',
        submitApi: '/property/passKey/assign'
      };
    }
    // this.communitySelect((data) => {
    //   this.communityList = data;
    // }, null, 1);
    this.mycommunitySelectByStep(1, undefined);
  },
  methods: {
    mycommunitySelectByStep (pageNum, search) {
      let params = {
        search,
        pageNum,
        pageSize: 30
      };

      this.$get({
        url: '/community/treeselect/page',
        params
      }).then(({data}) => {
        if (pageNum == undefined || pageNum == 1) {
          this.communityList = [].concat(data.rows);
          this.selectCurrentPage = 1;
        } else {
          this.communityList = this.communityList.concat(data.rows);
        }
        this.totalPage = data.totalPage;
        setTimeout(() => {
          this.isFetched = false;
        }, 150);
      });
    },
    // 当选择器为小区时 作分页展示
    selectScroll (e) {
      const { target } = e;
      const { scrollTop, scrollHeight, clientHeight } = target;
      if (scrollTop + 2 + clientHeight >= scrollHeight) {
        if (this.isFetched) { return; }
        this.selectCurrentPage += 1;
        if (this.selectCurrentPage <= this.totalPage) {
          this.isFetched = true;
          this.mycommunitySelectByStep(this.selectCurrentPage, this.searchValue);
        }
      }
    },
    selectSearch (e) {
      this.searchValue = e; // 搜索值
      this.selectCurrentPage = 1;
      if (this.isFetched) { return; }
      this.isFetched = true;
      this.mycommunitySelectByStep(this.selectCurrentPage, this.searchValue);
    },
    /** 上一步 */
    lastStep () {
      this.targetKeys = [];
      this.currentStep--;
    },
    /* 下一步 */
    next () {
      let fieldNames = [['communityId', 'userId', 'mobile']];
      this.form.validateFields(fieldNames[this.currentStep], (err, values) => {
        if (err) {
          this.stepStatus = 'error';
          return false;
        } else {
          this.$post({
            url: this.apiObj.nextApi ? this.apiObj.nextApi : '/passKey/authentication',
            params: values
          }).then(({data}) => {
            this.stepStatus = 'process';
            this.formValues = {...this.formValues, ...values};
            this.currentStep++;
            if (this.queryType) {
              this.roomData = data;
              this.roomData.roomList = this.roomData.deviceList.map(item => {
                return { roomAddress: item.deviceName };
              });
              let arr = [];
              data.deviceList.forEach(item => {
                arr.push({
                  key: `${item.deviceId}`,
                  title: item.deviceName,
                  disabled: false
                });
              });
              this.dataSource = arr;
            } else {
              this.roomData = data;
              let arr = [];
              data.deviceList.forEach((el) => {
                arr.push({
                  key: `${el.deviceId}`,
                  title: el.deviceName,
                  disabled: false
                });
              });
              this.dataSource = arr;
            }
          });
        }
      });
    },
    /* 表单提交 */
    handleSubmit  () {
      this.form.validateFields((err, values) => {
        values = {...values, ...this.formValues};
        values.deviceIds = values.deviceIds.join(',');
        if (err) {
          this.stepStatus = 'error';
          return false;
        } else {
          this.$post({
            url: this.apiObj.submitApi ? this.apiObj.submitApi : '/passKey/assign',
            params: values,
            btnLoading: this.btnLoading
          }).then(({ data }) => {
            let fromRoute = this.$store.state.fromRoute;
            let preRouteCached = this.$store.state.cachedViews.some(item => item === fromRoute.name);
            preRouteCached && this.$store.commit('DEL_CACHED_VIEW', fromRoute);

            this.stepStatus = 'finish';
            this.targetKeys = [];
            this.$message.success(`成功分配 ${data}把 钥匙`);
            this.$router.go(-1);
          });
        }
      });
    },
    /** 获取管家账号下拉（通过小区id） */
    selectChange (event) {
      this.form.setFieldsValue({ userId: '' });
      event && this.$get({
        url: '/property/user/treeselectByCommunityId',
        params: { communityId: event }
      }).then(({data}) => {
        this.userList = data;
      });
    }
  }
};
</script>
